(() => {
    (() => {
        function i(n) {
            Array.from(document.querySelectorAll(`${n} > button`)).forEach((e) => {
                e.addEventListener("click", () => {
                    e.previousElementSibling.showModal();
                });
            }),
                Array.from(document.querySelectorAll(`${n} > dialog > .header > button`)).forEach((e) => {
                    e.addEventListener("click", () => r(e.closest("dialog")));
                }),
                Array.from(document.querySelectorAll(`${n} > dialog`)).forEach((e) => {
                    e.addEventListener("click", (t) => {
                        if (t.target.tagName !== "DIALOG" || !t.target.hasAttribute("open")) return;
                        let o = t.target.getBoundingClientRect();
                        (o.top <= t.clientY &&
                            t.clientY <= o.top + o.height &&
                            o.left <= t.clientX &&
                            t.clientX <= o.left + o.width) ||
                        r(e);
                    });
                });
            function r(e) {
                console.log(e);
                let t = e.querySelector("iframe");
                t && t.contentWindow.postMessage(JSON.stringify({ event: "command", func: "pauseVideo" }), "*"),
                    e.close();
            }
        }
        window.addEventListener("load", () => {
            i("section.bp-wunderschoen-single-video");
        });
    })();
})();
//# sourceMappingURL=block.js.map
